import React from "react";
import ChatPanel from "@/components/ChatPanel";
import { useAuth } from "@/lib/auth";

export default function ClientMessages() {
  const { user } = useAuth();
  if (!user) return null;
  const roomId = `client_${user.user_id}`;
  return (
    <div data-testid="client-messages">
      <p className="overline">Talk to your project team</p>
      <h1 className="text-3xl font-heading font-medium text-[#0A2540] mt-2 mb-8">Messages</h1>
      <ChatPanel roomId={roomId} title="PowerBuilt Team" />
    </div>
  );
}
